import 'core-js/es/set';
import 'core-js/es/map';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import { enableMapSet } from 'immer';
import { BrowserRouter } from 'react-router-dom';

import React from 'react';
import ReactDOM from 'react-dom';
import Main from './Main';
import * as serviceWorker from './serviceWorker';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

// redux
import { Provider, shallowEqual, useSelector } from 'react-redux';
import configureStore from './redux/store';
import { initPosthog } from 'lib/posthog/usePosthogClient';
import { userInfoSelector } from 'redux/custom-selector';

// initPosthog();
enableMapSet();
const store = configureStore();
const AppContent = () => {
  const reduxData = useSelector(userInfoSelector, shallowEqual);
  const { ial: isAdminLogin } = reduxData?.UserInfo || {};

  React.useEffect(() => {
    if (isAdminLogin === false) {
      initPosthog(); // Initialize PostHog only if the user is not an admin
    }
  }, [isAdminLogin]);

  return isAdminLogin === false ? (
    <PostHogProvider client={posthog}>
      <BrowserRouter>
        <Main />
      </BrowserRouter>
    </PostHogProvider>
  ) : (
    <BrowserRouter>
      <Main />
    </BrowserRouter>
  );
};

const App = () => (
  <Provider store={store}>
    <AppContent />
  </Provider>
);

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
